<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Nueva categoría</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <!-- Reference -->
              <b-form-group
                id="input-reference"
                class="col-3"
                label="Nombre"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  v-model="$v.form.reference.$model"
                  :state="validateState('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <!-- <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-name_' + lang"
                :label="'Nombre (' + languageNames[i] + ')'"
                :label-for="'name_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'name_' + lang"
                  v-model="$v.form['name_' + lang].$model"
                  :state="validateState('name_' + lang)"
                  :aria-describedby="'input-name_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-name_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>
            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-description_' + lang"
                :label="'Descripción (' + languageNames[i] + ')'"
                :label-for="'description_' + lang"
                class="col-3"
              >
                <b-form-textarea
                  :id="'description_' + lang"
                  v-model="$v.form['description_' + lang].$model"
                  :state="validateState('description_' + lang)"
                  :aria-describedby="'input-description_' + lang + '- feedback'"
                ></b-form-textarea>
                <b-form-invalid-feedback
                  :id="'input-description_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row> -->

            <b-button type="submit" variant="primary"
              >Guardar nueva categoría</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  minLength,
  decimal,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

export default {
  name: 'AdminEmbroideryCategoriesNewScreen',
  props: {},
  components: {},
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },
      parent: {},
    };

    this.languageCodes.map((x) => {
      // Only 'es' lang required
      // rules['name_' + x] = x === 'es' ? { required } : {};
      // rules['description_' + x] = x === 'es' ? { required } : {};
    });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      // name: '',
      description: '',
      parent: null,
      reference: '',
      error: {
        show: false,
        text: '',
      },
    };

    store.getLanguageCodes().map((x) => {
      // form['name_' + x] = '';
      // form['description_' + x] = '';
    });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      parentOptions: [],
      form: form,
    };
  },
  created() {
    actions.getEmbroideryCategoriesUnpaginated().then((x) => {
      this.parentOptions = x.data.results.map((y) => {
        return {
          value: y.id,
          text: y.reference,
        };
      });
      this.parentOptions.push({ value: null, text: '-' });
    });
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {
        reference: this.form.reference,
        parent: this.form.parent,
      };

      this.languageCodes.map((x) => {
        // data['name_' + x] = this.form['name_' + x];
        // data['description_' + x] = this.form['description_' + x];
      });

      // data['name'] = this.form['name_' + this.languageCodes[0]];
      // data['description'] = this.form['description_' + this.languageCodes[0]];

      actions.postEmbroideryCategory(data).then((x) => {
        this.$router.push({ name: 'AdminEmbroideryCategoriesScreen' });
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
